import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

const DataListProductDetails = ({ listProducts }) => {
  function productNameFormatter(cell, row) {
    return (
      <span>
        <span className="badge badge-light border mr-2">
          {row.product.productCode}
        </span>
        <strong>{row.product.name}</strong>
        <small className="text-muted d-block">{row.product.barcode}</small>
      </span>
    );
  }

  function ecartFormatter(cell) {
    const value = Number(cell);
    if (!value) return <span className="text-muted">0</span>;
    return (
      <span
        className={`badge ${value > 0 ? "badge-success" : "badge-danger"}`}
        style={{ fontSize: "0.9rem" }}
      >
        {value > 0 ? `+${value}` : value}
      </span>
    );
  }

  const columnsProducts = [
    {
      dataField: "product",
      text: "Produit",
      formatter: productNameFormatter,
    },
    {
      dataField: "oldQuantity",
      text: "Quantité en stock",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "ecartQuantity",
      text: "Écart",
      align: "center",
      headerAlign: "center",
      formatter: ecartFormatter,
    },
    {
      dataField: "newQuantity",
      text: "Nouvelle quantité",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => <strong>{cell}</strong>,
    },
  ];

  return (
    <div className="row">
      {listProducts && (
        <ToolkitProvider
          keyField="id"
          data={listProducts}
          columns={columnsProducts}
        >
          {(props) => (
            <div className="w-100">
              <BootstrapTable
                {...props.baseProps}
                headerClasses="thead-light"
                wrapperClasses="table-responsive w-100"
                striped
                hover
                condensed
              />
            </div>
          )}
        </ToolkitProvider>
      )}
    </div>
  );
};
export default DataListProductDetails;
